var Component = require("!../../../../node_modules/.11.1.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=script&index=0!./slider.vue"),
  /* template */
  require("!!../../../../node_modules/.11.1.4@vue-loader/lib/template-compiler?{\"id\":\"data-v-7af68b9f\"}!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=template&index=0!./slider.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/packages/slider/src/slider.vue
// module id = 211
// module chunks = 0